import * as types from "./types";

// Action creators for VAPI voice assistant
export const startVapiCall = (assistantId, languageConfig = null) => ({
  type: types.VAPI_CALL_START,
  payload: { assistantId, languageConfig },
});

export const endVapiCall = () => ({
  type: types.VAPI_CALL_END,
});

export const vapiCallError = (error) => ({
  type: types.VAPI_CALL_ERROR,
  payload: { error },
});

export const updateVapiCallStatus = (isCallActive) => ({
  type: types.VAPI_CALL_STATUS_UPDATE,
  payload: { isCallActive },
});

export const updateVapiTranscript = (transcript) => ({
  type: types.VAPI_TRANSCRIPT_UPDATE,
  payload: { transcript },
});

export const updateVapiSpeakingStatus = (isSpeaking) => ({
  type: types.VAPI_SPEAKING_STATUS_UPDATE,
  payload: { isSpeaking },
});

export const setVapiElapsedTime = (elapsedTime) => ({
  type: types.VAPI_SET_ELAPSED_TIME,
  payload: { elapsedTime },
});

export const setVapiServiceReady = (isReady) => ({
  type: types.VAPI_SERVICE_READY,
  payload: { isReady },
});

export const setVapiServiceError = (error) => ({
  type: types.VAPI_SERVICE_ERROR,
  payload: { error },
});

export const showVapiPermissionCheck = (assistantId) => ({
  type: types.VAPI_SHOW_PERMISSION_CHECK,
  payload: { assistantId },
});

export const hideVapiPermissionCheck = () => ({
  type: types.VAPI_HIDE_PERMISSION_CHECK,
});

export const vapiCallConnected = (callData) => ({
  type: types.VAPI_CALL_CONNECTED,
  payload: { callData },
});

export const sendVapiBackgroundMessage = (message, type = "user") => ({
  type: types.VAPI_SEND_BACKGROUND_MESSAGE,
  payload: { message, type },
});

export const toggleVapiMute = () => ({
  type: types.VAPI_TOGGLE_MUTE,
});

export const vapiSay = (message, endCallAfterSpoken = false) => ({
  type: types.VAPI_SAY,
  payload: { message, endCallAfterSpoken },
});

export const vapiSayAndMuteAfter = (message, endCallAfterSpoken = false) => ({
  type: types.VAPI_SAY_AND_MUTE_AFTER,
  payload: { message, endCallAfterSpoken },
});

export const muteVapiAssistant = () => ({
  type: types.VAPI_MUTE_ASSISTANT,
});

export const unmuteVapiAssistant = () => ({
  type: types.VAPI_UNMUTE_ASSISTANT,
});

export const toggleVapiAssistantMute = () => ({
  type: types.VAPI_TOGGLE_ASSISTANT_MUTE,
});

export const setAssistantJoinedCall = (hasJoined = true) => ({
  type: types.VAPI_ASSISTANT_JOINED_CALL,
  payload: { hasJoined },
});

export const setWaitingForAssistant = (isWaiting = true) => ({
  type: types.VAPI_SET_WAITING_FOR_ASSISTANT,
  payload: { isWaiting },
});

export const setCallQuota = (quotaSeconds, isUpgraded = false) => ({
  type: types.VAPI_SET_CALL_QUOTA,
  payload: { quotaSeconds, isUpgraded },
});

export default {
  startVapiCall,
  endVapiCall,
  vapiCallError,
  updateVapiCallStatus,
  updateVapiTranscript,
  updateVapiSpeakingStatus,
  setVapiElapsedTime,
  setVapiServiceReady,
  setVapiServiceError,
  showVapiPermissionCheck,
  hideVapiPermissionCheck,
  vapiCallConnected,
  sendVapiBackgroundMessage,
  toggleVapiMute,
  vapiSay,
  vapiSayAndMuteAfter,
  muteVapiAssistant,
  unmuteVapiAssistant,
  toggleVapiAssistantMute,
  setAssistantJoinedCall,
  setWaitingForAssistant,
  setCallQuota,
};
